"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryRulesBase = void 0;
const lodash_1 = __importDefault(require("lodash"));
const DeliveryRule_1 = require("./DeliveryRule");
const PickAndPackRule_1 = require("./PickAndPackRule");
const BlockedPickAndPackDatesManager_1 = require("./BlockedPickAndPackDatesManager");
// Updated DeliveryRules class to ensure all interactions with DeliveryRuleDefinition go through DeliveryRule instances
class DeliveryRulesBase {
    initializeRules(deliveryRuleDefinitions) {
        this.deliveryRulesByKey = {};
        this.deliveryRulesByRegion = {};
        for (const ruleDefinition of deliveryRuleDefinitions) {
            if (ruleDefinition.pickAndPack) {
                const pickAndPackRule = new PickAndPackRule_1.PickAndPackRule(ruleDefinition);
                this.blockedPickAndPackDatesManager.add(pickAndPackRule);
                continue;
            }
            const deliveryRule = new DeliveryRule_1.DeliveryRule(ruleDefinition);
            const key = deliveryRule.getKey();
            if (!key) {
                continue;
            }
            if (this.deliveryRulesByKey[key] == null) {
                this.deliveryRulesByKey[key] = [];
            }
            this.deliveryRulesByKey[key].push(deliveryRule);
            this.addToRegionMap(deliveryRule, key);
        }
    }
    constructor(deliveryRules) {
        this.deliveryRulesByKey = {};
        this.deliveryRulesByRegion = {};
        this.blockedPickAndPackDatesManager = new BlockedPickAndPackDatesManager_1.BlockedPickAndPackDatesManager();
        if (deliveryRules) {
            this.initializeRules(deliveryRules);
        }
    }
    addToRegionMap(deliveryRule, key) {
        const region = deliveryRule.getRegion();
        if (!this.deliveryRulesByRegion[region]) {
            this.deliveryRulesByRegion[region] = {};
        }
        if (!this.deliveryRulesByRegion[region][key]) {
            this.deliveryRulesByRegion[region][key] = [];
        }
        this.deliveryRulesByRegion[region][key].push(deliveryRule);
    }
    getRawDeliveryRules() {
        const rules = Object.values(this.deliveryRulesByKey).flat();
        const ruleDefinitions = rules.map((rule) => rule.exportAsDeliveryRuleDefinition());
        if (!ruleDefinitions || ruleDefinitions.length === 0) {
            return null;
        }
        // Remove duplicate objects by converting them to json strings and using lodash uniq
        return lodash_1.default.uniqWith(ruleDefinitions, lodash_1.default.isEqual);
    }
    setRules(deliveryRules) {
        this.initializeRules(deliveryRules ?? []);
    }
    addDeliveryRule(deliveryRule) {
        const rawRules = this.getRawDeliveryRules() || [];
        this.initializeRules([...rawRules, deliveryRule.getDefinition()]);
    }
    removeDeliveryRule(region, key) {
        if (!this.deliveryRulesByRegion[region]) {
            return;
        }
        delete this.deliveryRulesByRegion[region][key];
        if (!this.deliveryRulesByKey[key]) {
            return;
        }
        this.deliveryRulesByKey[key] = this.deliveryRulesByKey[key].filter((deliveryRule) => {
            return deliveryRule.getRegion() !== region;
        });
    }
    getRulesWithRegion(region) {
        return Object.values(this.deliveryRulesByRegion[region] ?? []).flat();
    }
    getPickAndPackBlockedRules() {
        return this.blockedPickAndPackDatesManager.getAllRules();
    }
    getUniqueRegions() {
        return Object.keys(this.deliveryRulesByRegion);
    }
    changeRegion(oldRegion, newRegion) {
        if (oldRegion === newRegion) {
            return;
        }
        if (this.deliveryRulesByRegion && this.deliveryRulesByRegion[oldRegion]) {
            for (const key of Object.keys(this.deliveryRulesByRegion[oldRegion])) {
                if (this.deliveryRulesByRegion[oldRegion] &&
                    this.deliveryRulesByRegion[oldRegion][key]) {
                    for (const rule of this.deliveryRulesByRegion[oldRegion][key]) {
                        rule.setRegion(newRegion);
                    }
                }
            }
        }
        const rules = this.deliveryRulesByRegion[oldRegion];
        delete this.deliveryRulesByRegion[oldRegion];
        if (rules) {
            this.deliveryRulesByRegion[newRegion] = rules;
        }
    }
}
exports.DeliveryRulesBase = DeliveryRulesBase;
